import './floating_label_component.scss'
import { Controller } from 'stimulus'
import { createPopper } from '@popperjs/core'
import { desktop } from 'relation-map/utils'

export default class extends Controller {
  static targets = ['text']
  static classes = ['visible']

  connect = (): void => {
    this.virtualElement = { getBoundingClientRect: this.generateGetBoundingClientRect() }
    this.popperInstance = createPopper(this.virtualElement, this.element)
  }

  show = (text: string): void => {
    this.element.classList.add(this.visibleClass)
    this.textTarget.innerHTML = text
  }

  hide = (): void => {
    this.element.classList.remove(this.visibleClass)
    this.textTarget.innerHTML = ''
  }

  update = (event: Event): void => {
    this.virtualElement.getBoundingClientRect = this.generateGetBoundingClientRect(event.clientX, event.clientY)
    this.popperInstance.update()
  }

  private readonly generateGetBoundingClientRect = (x: number = 0, y: number = 0): object => {
    return () => ({
      width: 0,
      height: 0,
      top: y + this.offset,
      right: x + this.offset,
      bottom: y + this.offset,
      left: x + this.offset
    })
  }

  private get offset (): number {
    if (desktop()) return 24
    return 18
  }
}
